import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InitialConfigModel, DeferredConfigModel, SessionInfoModel } from '../../models';
import { CustomizedHttpService } from '../base/customized-http.service';

@Injectable({
  providedIn: 'root'
})
export class StartUpConfigService {

  constructor(private httpService: CustomizedHttpService, @Inject('BASE_URL') private originUrl: string) { }

  getSessionConfig(): Observable<SessionInfoModel> {
    return this.httpService.get<SessionInfoModel>(`${this.originUrl}startUpConfig/getSessionConfig`);
  }

  getInitialConfig(): Observable<InitialConfigModel> {
    return this.httpService.get<InitialConfigModel>(`${this.originUrl}StartUpConfig/GetInitialConfig`);
  }

  getDeferredConfig(): Observable<DeferredConfigModel> {
    return this.httpService.get<DeferredConfigModel>(`${this.originUrl}startUpConfig/getDeferredConfig`);
  }
}
